
export const getLockStatus = (state: any) => {
  const encounterInfo = state.encounterInfo;

  // นักศึกษา (ไม่มี teacher role) ถูก lock หลังกด Finish Editing
  const isStudentLocked =
    !!state.studentApproval &&
    !!(
      state.userPosition?.student_flag &&
      !state.userPosition?.teacher_flag &&
      encounterInfo?.den_approve_status === "FINISH_EDITING"
    );

  // Approve แล้วแก้ไม่ได้
  const isApproved = !!state.studentApproval && encounterInfo?.den_approve_status === "APPROVED";

  const isDischarged = ["CHECKED_OUT", "WAIT_PAY", "WAIT_DISPENSE", "DISCHARGED"].includes(encounterInfo?.status);
  const isBlank = encounterInfo?.den_approve_status === "BLANK";
  const hasNoEncounter = !encounterInfo?.number;

  return { isStudentLocked, isApproved, isDischarged, isBlank, hasNoEncounter };
};

export const checkIsEditDiagram = (
  state: any,
  masterData: any,
  data?: { clinicalFindingList?: any[]; periodontiumData?: any }
) => {
  const periodontiumData = data?.periodontiumData || state.periodontiumRecord?.data || {};
  const clinicalFindingListData: any[] = data?.clinicalFindingList || state.clinicalFindingList || [];

  let organList: any[] = [];

  const checkPSRList = Object.keys(periodontiumData || {}).filter((i: string) => i.startsWith("psr_"));

  // Every location except Plaque
  if (masterData?.organ?.items?.length > 0) {
    const locationList = clinicalFindingListData
      .map((item: any) => item.locations_name)
      .join()
      .split(",")
      .map((item: string) => item.trim())
      .filter((item: string) => item);

    organList = locationList.map((item: string) => masterData.organ.items.find((organ: any) => organ?.nickName === item)?.tissue);
  }

  // Looking on drawing
  const imageList = clinicalFindingListData
    .map((item: any) => (item.image ? Object.keys(item.image).join() : undefined))
    .join()
    .split(",")
    .filter((item: string) => item);

  const isDentalExamData = !checkEmptyObject(state.dentalExamData);
  const isFaceExamData = !checkEmptyObject(state.faceExamData);
  const isMuscleExamData = !checkEmptyObject(state.muscleExamData);
  const isSoftTissueExamData = !checkEmptyObject(state.softTissueExamData);
  const isPeriodontalExamData = !checkEmptyObject(state.periodontalExamData?.data || {});

  return {
    isEditDental:
      organList.includes("tooth") ||
      imageList.includes("primary_teeth") ||
      imageList.includes("permanent_teeth") ||
      isDentalExamData,
    isEditMuscle: organList.includes("muscle") || imageList.includes("muscle") || isMuscleExamData,
    isEditFace: organList.includes("face") || imageList.includes("face") || isFaceExamData,
    isEditSoft: organList.includes("soft") || imageList.includes("soft") || isSoftTissueExamData,
    isEditJaw: organList.includes("jaw") || imageList.includes("jaw"),
    isEditPlaque:
      periodontiumData?.bleeding?.length > 0 ||
      periodontiumData?.plaque?.length > 0 ||
      checkPSRList.length > 0 ||
      imageList.includes("periodontium") ||
      isPeriodontalExamData,
  };
};

export function checkEmptyObject(obj: any) {
  return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype;
}

// remount เมื่อเปลี่ยนผู้ป่วย / encounter
export const getDENRootKey = (props: { patientId?: number | null; encounterId?: number | null }) =>
  `${props.patientId ?? ""}-${props.encounterId ?? ""}`;
